import DailyStatsChartCardComponent from 'components/DailyStatsChartCard';
import useTrackPageLoad from 'hooks/useTrackPageLoad';
import { usePublisherDashboard } from '../PublisherDashboardContext';
import { CHART_STATS_SELECTOR_OPTIONS } from './utils';

const DailyStatsChartCard: React.FunctionComponent = () => {
  const {
    dailyStats: { data },
  } = usePublisherDashboard();

  useTrackPageLoad({
    section: 'DiscoWidget',
    page: 'DailyStats',
    state: 'Populated',
  });

  return (
    <DailyStatsChartCardComponent
      cardTitle="Daily Stats Chart"
      initialSelectedSeries="load"
      seriesData={data}
      statOptions={CHART_STATS_SELECTOR_OPTIONS}
    />
  );
};

export default DailyStatsChartCard;
